import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";

/** Zona de arrastrar-y-soltar reutilizada por las 3 cargas masivas de fotos
 * (Servicios, Galería de resultados, Testimonios). Soporta selección múltiple
 * por click o por drag & drop. */
export default function BulkDropzone({ onFiles, accept, label, hint, testId }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const handleFiles = (fileList) => {
    const files = Array.from(fileList || []);
    if (files.length > 0) onFiles(files);
  };

  return (
    <div
      className={`border-2 border-dashed rounded-xl p-10 text-center cursor-pointer transition-colors ${
        dragging ? "border-brand bg-brand-light/40" : "border-border hover:border-brand/50"
      }`}
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
      onDragLeave={() => setDragging(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragging(false);
        handleFiles(e.dataTransfer.files);
      }}
      data-testid={testId}
    >
      <UploadCloud className="w-8 h-8 text-brand mx-auto mb-2" />
      <p className="text-sm font-medium text-foreground">{label}</p>
      {hint && <p className="text-xs text-muted-foreground mt-1">{hint}</p>}
      <input
        ref={inputRef}
        type="file"
        multiple
        accept={accept}
        className="hidden"
        onChange={(e) => { handleFiles(e.target.files); e.target.value = ""; }}
      />
    </div>
  );
}
